import Vue from 'vue'
import Vuex from 'vuex'
import cache from './modules/cache'
import device from './modules/device';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        cache,
        device
    }
})